var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHands = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 52,
    viewBox: "0 0 65 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2071 19.8655H34.0231V25.4338C34.0231 29.4112 30.7266 32.5932 26.8307 32.5932C22.8349 32.5932 19.6383 29.4112 19.6383 25.4338V13.4022L13.1451 17.2802C11.1472 18.3739 10.0484 20.4621 10.0484 22.7491V27.4225L2.05684 31.9965C0.458521 32.8915 -0.040952 34.8802 0.8581 36.3717L8.84967 50.0937C9.74872 51.6847 11.6467 52.1818 13.245 51.2869L23.5342 45.3208H37.2197C40.7161 45.3208 43.613 42.5367 43.613 38.957H45.2113C46.9095 38.957 48.4079 37.5649 48.4079 35.7751V29.4112H49.2071C50.5057 29.4112 51.6046 28.4169 51.6046 27.0248V22.2519C51.6046 20.9593 50.5057 19.8655 49.2071 19.8655ZM63.8916 16.1864L55.9 2.36491C55.001 0.873388 53.103 0.376213 51.6046 1.27113L41.2155 7.13779H31.0263C29.8275 7.13779 28.6288 7.53553 27.6299 8.13214L24.3333 10.2203C23.3344 10.8169 22.8349 11.8112 22.8349 12.905V25.4338C22.8349 27.7208 24.5331 29.4112 26.8307 29.4112C29.0284 29.4112 30.8265 27.7208 30.8265 25.4338V16.6836H49.2071C52.2039 16.6836 54.8012 19.2689 54.8012 22.2519V25.1355L62.7928 20.5615C64.2912 19.6666 64.7907 17.6779 63.8916 16.1864Z",
    fill: "#1D2A30"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHands, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hands.4cc3e518.svg";
export { ForwardRef as ReactComponent };